import cx from "classnames"
import { camelize } from "../../utils"
import type { IconColorsType } from "../"
export type IconProps = {
  color?: IconColorsType
  size?: 16 | 20 | 24 | 32
  contained?: boolean
  className?: string
}
const iconSource = "questionCircle"
const QuestionCircleIcon = ({
  color,
  size = 24,
  contained = false,
  className,
}: IconProps) => {
  const computedClassName = cx(
    className,
    `cobalt-Icon cobalt-Icon--${iconSource}`,
    {
      [`c-fill-${camelize(color || "")}`]: color,
      "cobalt-Icon--size16": size === 16,
      "cobalt-Icon--size20": size === 20,
      "cobalt-Icon--size32": size === 32,
      "cobalt-Icon--contained": contained,
    },
  )
  return (
    <span className={computedClassName}>
      {
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
          <title>{iconSource}</title>
          <path d="M12 15.375C12.621 15.375 13.125 15.879 13.125 16.5S12.621 17.625 12 17.625 10.875 17.121 10.875 16.5 11.379 15.375 12 15.375M10.637 6.459C11.287 6.188 12.004 6.119 12.695 6.256S14.021 6.733 14.52 7.23 15.357 8.364 15.494 9.055C15.632 9.745 15.561 10.462 15.291 11.113S14.566 12.32 13.98 12.712C13.659 12.926 13.306 13.084 12.938 13.184V14.438H11.062V12.188C11.063 11.774 11.399 11.438 11.813 11.438H12C12.334 11.438 12.66 11.338 12.938 11.153S13.432 10.704 13.559 10.396C13.687 10.088 13.72 9.748 13.655 9.421S13.43 8.793 13.193 8.557 12.656 8.16 12.33 8.095 11.662 8.063 11.354 8.19C11.046 8.318 10.782 8.535 10.597 8.812 10.41 9.09 10.313 9.417 10.313 9.75H8.437C8.438 9.046 8.648 8.357 9.039 7.771 9.43 7.185 9.986 6.728 10.637 6.459" />
          <path
            fillRule="evenodd"
            d="M12 1.5C17.799 1.5 22.5 6.201 22.5 12S17.799 22.5 12 22.5 1.5 17.799 1.5 12 6.201 1.5 12 1.5M12 3C7.03 3 3 7.03 3 12S7.03 21 12 21 21 16.97 21 12 16.97 3 12 3"
            clipRule="evenodd"
          />
        </svg>
      }
    </span>
  )
}
export default QuestionCircleIcon
